import auth from "services/account";
import * as types from "../mutation-types";

const state = {
  isLoggedIn: null,
  account: {},
  token: null,
  message: null,
  status: null,
  pending: false,
  registerPending: false,
  registerStatus: null
};

const mutations = {
  [types.LOGIN](state) {
    state.pending = true;
  },

  [types.LOGIN_SUCCESS](state) {
    state.isLoggedIn = true;
    state.pending = false;
    state.message = "Authenticated";
  },
  [types.LOGOUT](state) {
    state.isLoggedIn = false;
    state.token = "";
    state.account = {};
  },
  [types.ACCOUNT_MSG](state, payload) {
    state.message = payload.statusText;
    if (payload.data && payload.data.message) {
      state.message = payload.data.message;
    }
    state.status = payload.status;
    state.pending = false;
  },
  [types.REGISTER](state, payload) {
    state.registerPending = true;
  },
  [types.REGISTERED](state, payload) {
    state.registerStatus = payload.status;
    if (payload.status_code) {
      state.registerStatus = payload.status_code;
    }

    state.registerPending = false;
  },
  [types.SAVING_ACCOUNT](state) {
    state.pending = true;
  },
  [types.SAVED_ACCOUNT](state, payload) {
    state.account = payload;
    state.pending = false;
  },

  [types.SET_ACCOUNT](state, payload) {
    state.token = payload.meta.token;
    state.account = payload.user;
  },
  [types.REFRESH_ACCOUNT](state, payload) {
    //state.token = payload.meta.token
    state.account = payload;
  },
  setRefreshedAccount(state, payload) {
    //state.token = payload.meta.token
    state.account = payload;
  },
};

const getters = {
  isLoggedIn: state => state.isLoggedIn,
  getAccount: state => state.account,
  getToken: state => state.token,
  getRoles: state => state.account.roles,
  getStatus: state => state.status
};

const actions = {
  async checkAccount({ commit }) {
    commit(types.SAVING_ACCOUNT);
    const payload = await auth.checkIsAdmin();
    if ((await payload.status) === 200) {
      commit(types.REFRESH_ACCOUNT, await payload.data.user);
      if (!_.isEmpty(await payload.data.user.candidates)) {
        commit("candidate/SET_CANDIDATE", await payload.data.user, {
          root: true
        });
      }
    }
    commit(types.ACCOUNT_MSG, await payload);
  },
  async register({ commit }, credentials) {
    commit(types.REGISTER);
    commit("candidate/SET_CANDIDATE", {}, { root: true });
    const payload = await auth.register(credentials);
    commit(types.REGISTERED, await payload);

    if ((await payload.status) === 200) {
      commit(types.SET_ACCOUNT, await payload.data);

      if (!_.isEmpty(await payload.data.user.candidates)) {
        commit("candidate/SET_CANDIDATE", await payload.data.user, {
          root: true
        });
      } else {
        commit("candidate/RESET_CANDIDATE", await payload.data, { root: true });
      }
      commit(types.LOGIN_SUCCESS);
    }
    commit(types.ACCOUNT_MSG, await payload);
  },
  async shopRegister({ commit }, credentials) {
    commit(types.REGISTER);
    commit("candidate/SET_CANDIDATE", {}, { root: true });
    const payload = await auth.shopRegister(credentials);
    commit(types.REGISTERED, await payload);

    if ((await payload.status) === 200) {
      commit(types.SET_ACCOUNT, await payload.data);
      commit(types.LOGIN_SUCCESS);
    }
    commit(types.ACCOUNT_MSG, await payload);
  },
  async adminRegister({ commit }, credentials) {
    commit(types.REGISTER);
    const payload = await auth.adminRegister(credentials);
    commit(types.REGISTERED, await payload);
    commit(types.ACCOUNT_MSG, await payload);
  },
  async login({ commit }, credentials) {
    commit(types.LOGIN);
    commit("candidate/SET_CANDIDATE", {}, { root: true });
    const payload = await auth.login(credentials);

    if ((await payload.status) === 200) {
      commit(types.SET_ACCOUNT, await payload.data);
      if (!_.isEmpty(await payload.data.user.candidates)) {
        commit("candidate/SET_CANDIDATE", await payload.data.user, {
          root: true
        });
      }
      commit(types.LOGIN_SUCCESS);
    }

    commit(types.ACCOUNT_MSG, await payload);
  },
  async logout({ commit }) {
    const payload = (await auth.logout()).data;
    commit(types.LOGOUT);
    commit(types.ACCOUNT_MSG, await payload);
    commit("orders/resetOrders", null, { root: true });
  },
  async lostPassword({ commit }, email) {
    commit(types.LOGIN);
    const payload = await auth.lostPassword(email);
    commit(types.ACCOUNT_MSG, await payload);
  },
  async resetPassword({ commit }, credentials) {
    commit(types.LOGIN);
    const payload = await auth.resetPassword(credentials);
    commit(types.REFRESH_ACCOUNT, await payload.data.user);
    commit(types.ACCOUNT_MSG, await payload);
  },
  async setAccount({ commit }) {
    try {
      const payload = await auth.refresh();
      commit(types.REFRESH_ACCOUNT, await payload.data);
      if (!_.isEmpty(await payload.data.candidates)) {
        commit("candidate/SET_CANDIDATE", await payload.data, { root: true });
      } else {
        commit("candidate/RESET_CANDIDATE", await payload.data, { root: true });
      }
      commit(types.LOGIN_SUCCESS);
    } catch (e) {
      commit(types.LOGOUT);
      commit("candidate/SET_CANDIDATE", {}, { root: true });
    }
  },
  async saveAccount({ commit }, account) {
    commit(types.SAVING_ACCOUNT);
    const payload = await auth.saveAccount(account);
    if ((await payload.status) === 200) {
      commit(types.SAVED_ACCOUNT, await payload.data);
      if (!_.isEmpty(await payload.data.candidates)) {
        commit("candidate/SET_CANDIDATE", await payload.data, { root: true });
      }
    }
    commit(types.ACCOUNT_MSG, await payload);
  },
  async updateAccount({ commit }, account) {
    commit(types.SAVING_ACCOUNT);
    const payload = await auth.updateAccount(account);
    if ((await payload.status) === 200) {
      commit(types.SAVED_ACCOUNT, await payload.data);
      if (!_.isEmpty(await payload.data.candidates)) {
        commit("candidate/SET_CANDIDATE", await payload.data, { root: true });
      }
    }
    commit(types.ACCOUNT_MSG, await payload);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
